import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl+ "Daro/Calendar?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  Add(geoDate: string,dsc:string,Token:String):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      token:Token,
      geoDate:geoDate,
      dsc:dsc,
      id:0
    }


      return this.http.post(environment.BaseUrl + "Daro/Calendar/Add",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
      )

  }

  Delete(Token:String,id:number):Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Calendar/Delete?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as any
      })
    )
  }


}
